import { render, staticRenderFns } from "./EditAdvertisement.vue?vue&type=template&id=15bc5f1a&scoped=true&"
import script from "./EditAdvertisement.vue?vue&type=script&lang=js&"
export * from "./EditAdvertisement.vue?vue&type=script&lang=js&"
import style0 from "./EditAdvertisement.vue?vue&type=style&index=0&id=15bc5f1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc5f1a",
  null
  
)

export default component.exports